import { Box, Header, Text } from 'grommet';
import React from 'react'

import { Menu } from "grommet-icons";
import { ReactComponent as Logo } from "../config/logo.svg";
import { useLocation, useNavigate } from 'react-router-dom';

const KnueHeader = () => {
  let navigate = useNavigate();
  let location = useLocation();
//   console.log("KnueHeader", location)
  const gotoMain = () => {
    navigate("/archive")
  }

  return(
    <Header flex={false}>
      <Box
        width="full"
        style={{ zIndex: "99" }}
        direction="row"
        align="center"
        justify="between"
        background="rgb(0,0,0,0.8)"
        pad={{ horizontal: "20px" }}
      >
        <Box margin={{ right: "10px" }}>
          <Logo />
        </Box>
        {location.pathname!=='/archive' && <Box direction="row" align="center"
          focusIndicator={false}
          hoverIndicator onClick={()=>gotoMain()}       >
          {/* <Button icon={<Menu />} /> */}
          <Text size="15px">한국 근현대 교육사 자료서비스</Text>
        </Box>}
      </Box>
    </Header>
  )

}



export default KnueHeader;